import CardsStack from '../../../website-mobile/components/CardsStack/CardsStack';
import '../../../website-mobile/mobile-scope.css';
import styles from './page5.module.css';

export default function Page5() {
    return (
        <div className={`${styles.page5} website-mobile-scope`}>
            <div className={styles.bgLines}>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
                <div className={styles.bgLine}></div>
            </div>
            <div className={styles.contentWrapper}>
                <CardsStack />
            </div>
        </div>
    );
}
